import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import moment from 'moment';

/**
 * Modal para mostrar observaciones de un ingreso
 * @param {Boolean} show - Controla la visibilidad del modal
 * @param {Function} onHide - Función para cerrar el modal
 * @param {Object} ingreso - Datos del ingreso con observaciones
 */
export const ObservacionModal = ({ show, onHide, ingreso }) => {
  if (!ingreso) return null;

  const numeroIngreso = `I-${ingreso?.numeroOrden}-${ingreso?.consecutivo}`;

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      size="lg"
    >
      <Modal.Header closeButton className="bg-info text-white">
        <Modal.Title className="d-flex align-items-center">
          <FaInfoCircle className="me-2" />
          Observaciones del Ingreso
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="w-100">
        {/* Información del Ingreso */}
        <div className="mb-4 p-3 bg-light rounded">
          <div className="row">
            <div className="col-md-6 mb-2">
              <strong className="text-muted">N° Ingreso:</strong>
              <div className="text-primary fw-bold">{numeroIngreso}</div>
            </div>
            <div className="col-md-6 mb-2">
              <strong className="text-muted">Estado:</strong>
              <div>{ingreso.estado}</div>
            </div>
            <div className="col-md-6 mb-2">
              <strong className="text-muted">Fecha Ingreso:</strong>
              <div>{moment(ingreso.fechaIngreso).format("DD/MM/YYYY HH:mm")}</div>
            </div>
            <div className="col-md-6 mb-2">
              <strong className="text-muted">Cliente:</strong>
              <div>{ingreso?.nameClient || ingreso?.equipos?.[0]?.equipo?.equipo?.cliente?.nombre || 'N/A'}</div>
            </div>
          </div>
        </div>

        {/* Observaciones */}
        <div>
          <h6 className="text-secondary mb-3">
            <i className="bi bi-chat-left-text me-2"></i>
            Observaciones:
          </h6>
          <div 
            className="p-3 border rounded bg-white"
            style={{ 
              minHeight: '100px',
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word'
            }}
          >
            {ingreso.observacion || 'Sin observaciones registradas.'}
          </div>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="w-100">
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
